import { useState } from 'react';
import { formatOverloadValue, summarizeOverloadOptions } from '../domain/personalNikke.js';

export function PersonalNikkeEquipmentPanel({ personal }) {
  const [open, setOpen] = useState(false);
  const equipped = personal.equipment.filter((item) => item.tid || item.tier);
  const effects = open ? summarizeOverloadOptions(personal.equipment) : [];

  return (
    <details className="personal-nikke-equipment-panel" open={open} onToggle={(event) => setOpen(event.currentTarget.open)}>
      <summary>
        <span className="personal-nikke-equipment-count"><span>장비</span><b>{equipped.length}/4</b></span>
        <em>오버로드</em>
        <span className="personal-nikke-equipment-chevron" aria-hidden="true">›</span>
      </summary>
      {open ? (
        <div className="personal-nikke-equipment-detail">
          <section className="personal-nikke-effect-summary" aria-label="오버로드 효과">
            <header><strong>오버로드</strong></header>
            {effects.length ? effects.map((effect) => (
              <div key={`${effect.effectType}-${effect.valueType}`}>
                <span>{effect.label}<small>×{effect.count}</small></span>
                <b>{formatOverloadValue(effect)}</b>
              </div>
            )) : <p>등록된 오버로드 효과가 없습니다.</p>}
          </section>
        </div>
      ) : null}
    </details>
  );
}
